import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { IconButton } from "components/support";

export default class CategoryUnitView extends Component {
  render() {
    const {
      category,
      onRequestCreate,
      onRequestEdit,
      onRequestDelete
    } = this.props;

    return (
      <Row middle="xs">
        <Col xs>{category.name}</Col>
        <Col>
          <IconButton
            mini
            icon="add_circle"
            onClick={() => onRequestCreate()}
          />
          <IconButton mini icon="mode_edit" onClick={() => onRequestEdit()} />
          <IconButton mini icon="delete" onClick={() => onRequestDelete()} />
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/category/list/category-unit/index.jsx